import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import useCepForm from './CepForm.hook';
import ConfigurationStep from './Steps/ConfigurationStep';
import EstimationCostStep from './Steps/EstimationCostStep';
import TacticsStep from './Steps/TacticsStep/TacticsStep';
import ButtonsBar from 'components/ButtonsBar';
import { CepFormPropsType, CepFormStepsIndex } from 'modules/maya/components/CepForm/CepForm.types';
import TargetListStep from 'modules/maya/components/CepForm/Steps/TargetListStep';
import {
  FormLayoutContainer,
  FormLayoutMidPanel,
  FormLayoutMidPanelContent,
  FormLayoutMidPanelHeader,
  FormLayoutRightPanel,
} from 'modules/maya/components/FormLayout';
import SideFormDetails from 'modules/maya/components/SideFormDetails';
import { YodaFormProvider } from 'services/yodaForm';
import Box from 'yoda-ui/Box';
import Stepper from 'yoda-ui/Stepper/Stepper';

const CepForm: FC<CepFormPropsType> = ({ submitCallback, isTemplate = false }) => {
  const {
    handleChangeStep,
    yodaFormMethods,
    stepIndexer,
    buttonsConfig,
    stepsList,
  } = useCepForm(submitCallback, isTemplate);
  const flags = useFlags();

  return (
    <YodaFormProvider { ...yodaFormMethods.providerFields }>
      <FormLayoutContainer>
        <FormLayoutMidPanel >
          <FormLayoutMidPanelHeader>
            <Stepper
              handleChangeStep={ handleChangeStep }
              stepsList={ stepsList }
              stepIndex={ stepIndexer.stepIndex }
            />
          </FormLayoutMidPanelHeader>
          <FormLayoutMidPanelContent>

            {
              stepIndexer.stepIndex === CepFormStepsIndex.configurationStep
                ? (
                  <Box width="100%">
                    <ConfigurationStep isTemplate={ isTemplate }/>
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepFormStepsIndex.targetListStep
                ? (
                  <Box width="100%">
                    <TargetListStep/>
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepFormStepsIndex.tacticsStep
                ? (
                  <Box width="100%">
                    <TacticsStep isTemplate={ isTemplate }/>
                  </Box>
                )
                : null
            }
            {
              flags.mayaFinanceBiogenlinc866 && stepIndexer.stepIndex === CepFormStepsIndex.costEstimationStep
                ? (
                  <Box width="100%">
                    <EstimationCostStep />
                  </Box>
                )
                : null
            }
          </FormLayoutMidPanelContent>
        </FormLayoutMidPanel>

        <FormLayoutRightPanel >
          <SideFormDetails />
        </FormLayoutRightPanel>

      </FormLayoutContainer>
      { buttonsConfig && <ButtonsBar { ...buttonsConfig } /> }
    </YodaFormProvider>
  );
};

export default CepForm;
